class contactHelper {
  static getContact (data, type) {
    const contacts = []

    if (data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].type === type) {
          contacts.push(data[i].contact)
        }
      }
    }

    return contacts
  }
  static getContactAllData (data, type) {
    const contacts = []

    if (data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].type === type) {
          contacts.push(data[i])
        }
      }
    }

    return contacts
  }
  static getContactObj (data, type) {
    const contacts = []

    if (data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].type === type) {
          contacts.push({ value: data[i].contact })
        }
      }
    }

    return contacts
  }
}

export default contactHelper
